export default {
  title: 'บริหารเวลาออนไลน์',
  home: 'หน้าหลัก',
  company: 'บริษัท',

  'company-table': require('./CompanyTable.js').default
}
